module.exports = __webpack_public_path__ + "static/media/bg_sheep.815a2910.png";